import { ADD_INSTRUCTOR, ADD_INSTRUCTOR_FAILED, ADD_INSTRUCTOR_SUCCESS } from '../actions/instructors'
import { errorMessageFromPayload } from '../utils/errors'
import {SYNC_RESET_DEVICE_SUCCESS} from "../actions/sync";

const defaultState = {
  adding: false,
  error: ''
};

export default function reducer(state = defaultState, action) {
  switch (action.type) {
    case ADD_INSTRUCTOR: {
      return {...state, adding: true}
    }
    case ADD_INSTRUCTOR_SUCCESS: {
      return {...state, adding: false, error: ''}
    }
    case ADD_INSTRUCTOR_FAILED: {
      return {...state, adding: false, error: errorMessageFromPayload(action.payload)}
    }
    case SYNC_RESET_DEVICE_SUCCESS: {
      return defaultState;
    }
    default:
      return state;
  }
}
